var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { mapProducts, mapFilters, mapMeta, mapSorts } from './mapper';
import { fetchUnbxd } from './api';
export class UnbxdSearchProvider {
    constructor() {
        this.products = [];
        this.filters = [];
        this.meta = null;
        this.sortOptions = [];
        this.currentFilters = {};
    }
    search(query_1) {
        return __awaiter(this, arguments, void 0, function* (query, options = {}) {
            if (options.filters) {
                this.updateFilters(options.filters);
            }
            try {
                const data = yield fetchUnbxd({
                    q: query,
                    page: options.page || 1,
                    pageSize: options.pageSize || 24,
                    sort: options.sort,
                    filters: this.currentFilters,
                    merchandising: options.merchandising,
                });
                this.products = mapProducts(data.response.products);
                this.filters = mapFilters(data.facets, this.currentFilters);
                this.meta = mapMeta(data, options.page || 1);
                this.sortOptions = mapSorts();
            }
            catch (error) {
                console.error('Error fetching from Unbxd:', error);
                throw error;
            }
        });
    }
    updateFilters(newFilters) {
        Object.entries(newFilters).forEach(([filterId, values]) => {
            if (values.length > 0) {
                if (filterId === 'price') {
                    this.currentFilters[filterId] = values;
                }
                else {
                    if (!this.currentFilters[filterId]) {
                        this.currentFilters[filterId] = [];
                    }
                    values.forEach((value) => {
                        const valueIndex = this.currentFilters[filterId].indexOf(value);
                        if (valueIndex === -1) {
                            this.currentFilters[filterId] = [
                                ...this.currentFilters[filterId],
                                value,
                            ];
                        }
                        else {
                            this.currentFilters[filterId] = this.currentFilters[filterId].filter((v) => v !== value);
                            if (this.currentFilters[filterId].length === 0) {
                                const _a = this.currentFilters, _b = filterId, _ = _a[_b], newFilters = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
                                this.currentFilters = newFilters;
                            }
                        }
                    });
                }
            }
        });
    }
    getProducts() {
        return this.products;
    }
    getFilters() {
        return this.filters;
    }
    getMeta() {
        if (!this.meta) {
            throw new Error('No search has been performed yet');
        }
        return this.meta;
    }
    getSortOptions() {
        return this.sortOptions;
    }
    getCurrentFilters() {
        return this.currentFilters;
    }
}
